import {
  Box,
  Typography,
} from "@material-ui/core";
import { TFunction } from "next-i18next";
import React from "react";
import GoogleIcon from "../../../public/img/GoogleIcon";
import useStyles from "../../../styles/components/DialogAuth";

type ModalRegisterProps = {
  readonly t: TFunction;
  handleLoginGoogle: () => void;
  handleChangeAuthData?: (data: any) => void;
  handleVerify?: () => void;
  handleLogin: () => void;
};

const ModalRegister = (props: ModalRegisterProps) => {
  const {
    t,
    handleLoginGoogle,
    handleLogin,
  } = props;
  const classes = useStyles();

  return (
    <Box textAlign="center">
      <Box my="24px">
        <Box className={classes.otherLoginMethod} style={{ justifyContent: "center", display: "flex" }}>
          <Box
            className={classes.loginMethodWrapper}
            onClick={handleLoginGoogle}
          >
            <GoogleIcon />
          </Box>
        </Box>
      </Box>
      <Typography variant="body2" style={{ marginBottom: "16px" }}>
        {t("already-have-account?")}{" "}
        <span className={classes.underlineButton} onClick={handleLogin}>
          {t("login")}
        </span>
      </Typography>
    </Box>
  );
};

export default ModalRegister;
